import {
  changePassword,
  forgotPassword
} from "./chunk-765NQUHW.mjs";

// src/hooks/wbk/auth/password.ts
import { useMutation } from "@tanstack/react-query";
var useForgotPassword = () => {
  return useMutation({
    mutationFn: forgotPassword
  });
};
var useChangePassword = () => {
  return useMutation({
    mutationFn: changePassword
  });
};

export {
  useForgotPassword,
  useChangePassword
};
//# sourceMappingURL=chunk-Z4P4YPW7.mjs.map